export const AppVersion = (json: IAppVersion): IAppVersionModel => ({
	requiredAndroid: json.required?.android ?? '',
	requiredIos: json.required?.ios ?? '',
	recommendedAndroid: json.recommended?.android ?? '',
	recommendedIos: json.recommended?.ios ?? '',
})

export const AppVersionToPayload = (model: IAppVersionModel): IAppVersionPayload => ({
	...toSnakeCase(model),
})
